/* eslint-disable eqeqeq */
import { Formik, FormikProps } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { useMutation } from "react-query";
import { UserContext } from "../../../Provider";
import { addInquirySchema } from "../../../Schema/CommerceCompassSchema";
import { AddIconCurrencyInput, AddIconDatePicker } from "../../../components/AddIconDatePicker";
import AGSelect from "../../../components/AgSelect";
import AGButton from "../../../components/Button";
import AGModal from "../../../components/Modal";
import AGTextarea from "../../../components/Textarea";
import { httpGET, httpPOST } from "../../../utils/ajaxHelper";
import { INQUIRY_CONSTANT, OFFERING_TYPE, INQUIRY_MORE_OPTION } from "../../../utils/constant";
import { compare } from "../../../utils/sort";
import {
  AddInquiryModelProps,
  ComMainService,
} from "./addInquiry.props";
import { FormContainer } from "./addInquiry.style";

import moment from "moment";
import AGCurrencyInput from "../../../components/CurrencyInput";
import AGInput from "../../../components/Input";
import { useNotification } from "../../../components/Notification";
// import AGRadioButtonV2 from "../../../components/RadioButton";
import { handleNumericDateInput } from "../../../utils/helper";
import { CustomBackground, StyledDatePicker } from "../addInquiryModal/addInquiry.style";
import { InquiryIndividualInfo } from "./addInquiry.props";

const AddInquiryModal = ({
  visible,
  toggleModal,
  inquiryCreatingInfo,
  countriesWithRegions,
  onCreateInquirySuccessfully,
  onPreCreateInquiry,
}: AddInquiryModelProps) => {
  const user = useContext(UserContext);
  const roleCheck = user?.roles.includes("Admin") || user?.roles.includes("ManagingPartner") || user?.roles.includes("FirmCommerceManagement");
  const isAdmin = user?.roles.includes("Admin");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobileScreen = screenWidth < 769;

  const [inquirySenders, setInquirySenders] = useState<InquiryIndividualInfo[]>([]);
  const [inquiryReceivers, setInquiryReceivers] = useState<InquiryIndividualInfo[]>([]);
  const [inquiryDate, setInquiryDate] = useState<Date | null>(null);
  const [mainServices, setMainServices] = useState<ComMainService[]>([]);
  const [mainProducts, setMainProducts] = useState<ComMainService[]>([]);
  const [mainSecondments, setMainSecondments] = useState<ComMainService[]>([]);
  const [isSecondmentSelected, setIsSecondmentSelected] = useState(false);

  const [submitCount, setSubmitCount] = useState(0);
  const [initialValues, setInitialValues] = useState({
    inquiryDate: null,
    inquirySenderFirm: user?.roles.includes("Admin") || inquiryCreatingInfo == null ? null : {
      value: inquiryCreatingInfo.inquirySenderFirms[0].firmId,
      label: inquiryCreatingInfo.inquirySenderFirms[0].firmName,
    },
    inquirySender: roleCheck || inquiryCreatingInfo == null ? null : {
      value: inquiryCreatingInfo.inquirySenders[0].inquirySenderId,
      label: inquiryCreatingInfo.inquirySenders[0].firstName + " " + inquiryCreatingInfo.inquirySenders[0].lastName,
    },
    inquiryReceiverFirm: null,
    inquiryReceiver: null,
    subject: "",
    body: "",
    offeringType: null,
    mainService: null,
    status: inquiryCreatingInfo === null ? null : {
      value: INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING,
      label: inquiryCreatingInfo.inquiryStatusTypes.find(x => x.statusId = INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING)?.status
    },
    dealValue: null,
    closeDate: null,
    typeOfClient: inquiryCreatingInfo === null ? null : {
      value: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_ID.UNKNOWN,
      label: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_NAME.UNKNOWN
    },
    requestedServices: null,
    senderRegion: null,
    senderCountry: null,
    receiverRegion: null,
    receiverCountry: null,
    businessGeneratingTypeId: INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
    onetimeFee: null,
    recurringFee: null,
    commentRemarks: "",
    frequencyOfRecurringFee: null,
  });

  // const [businessGeneratingCheckBox, setBusinessGeneratingCheckbox] =
  //   useState<InquiryBusinessGeneratingType>();

  const [showSpecializedSelect, setShowSpecializedSelect] = useState(0);
  const formRef = useRef<FormikProps<any>>(null);

  const { mutate: getSendersByFirmId } = useMutation(
    (firmId: number) =>
      httpGET({
        url: "/Individuals",
        params: { id: firmId },
      }),
    {
      onSuccess: (rs) => {
        setInquirySenders(rs);
      },
    },
  );

  const { mutate: getReceiversByFirmId } = useMutation(
    (firmId: number) =>
      httpGET({
        url: "/Individuals",
        params: { id: firmId },
      }),
    {
      onSuccess: (rs) => {
        setInquiryReceivers(rs);
      },
    },
  );

  const { mutate: getAllMainServices } = useMutation(
    () =>
      httpGET({
        url: `/ComMainService/get-all-main-services`,
      }),
    {
      onSuccess: (rs: ComMainService[]) => {
        if (rs.length > 0)
          setMainServices(rs.filter(item => item.fkOfferingTypeId === OFFERING_TYPE.SERVICE));
        setMainProducts(rs.filter(item => item.fkOfferingTypeId === OFFERING_TYPE.PRODUCT));
        setMainSecondments(rs.filter(item => item.fkOfferingTypeId === OFFERING_TYPE.SECONDMENT));
      },
    },
  );

  const { mutate: createInquiry } = useMutation(
    (data: any) =>
      httpPOST({
        url: "/Inquiry/create",
        data: data,
      }),
    {
      onSuccess: (rs) => {
        onCreateInquirySuccessfully();
        handleClose();
      },
      onError: (error) => {
        showNotification("Error happened", "Error");
      },
    },
  );

  useEffect(() => {
    if (!user?.roles.includes("Admin")) {
      user?.individual?.fkOrgId && getSendersByFirmId(user?.individual?.fkOrgId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible])

  useEffect(() => {
    getAllMainServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (inquiryCreatingInfo !== null) {
      // setBusinessGeneratingCheckbox({
      //   businessGeneratingTypeId: INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
      //   businessGeneratingTypeName: inquiryCreatingInfo.inquiryBusinessGeneratingTypes.find(
      //     (x) =>
      //       x.businessGeneratingTypeId === INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
      //   )?.businessGeneratingTypeName,
      //   isCheck: true,
      // });
      setInitialValues({
        inquiryDate: null,
        inquirySenderFirm: user?.roles.includes("Admin") ? null : {
          value: inquiryCreatingInfo.inquirySenderFirms[0].firmId,
          label: inquiryCreatingInfo.inquirySenderFirms[0].firmName,
        },
        inquirySender: roleCheck ? null : {
          value: inquiryCreatingInfo.inquirySenders[0].inquirySenderId,
          label: inquiryCreatingInfo.inquirySenders[0].firstName + " " + inquiryCreatingInfo.inquirySenders[0].lastName,
        },
        inquiryReceiverFirm: null,
        inquiryReceiver: null,
        subject: "",
        body: "",
        offeringType: null,
        mainService: null,
        status: inquiryCreatingInfo === null ? null : {
          value: INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING,
          label: inquiryCreatingInfo.inquiryStatusTypes.find(x => x.statusId === INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING)?.status
        },
        dealValue: null,
        closeDate: null,
        typeOfClient: inquiryCreatingInfo === null ? null : {
          value: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_ID.UNKNOWN,
          label: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_NAME.UNKNOWN
        },
        requestedServices: null,
        senderRegion: null,
        senderCountry: null,
        receiverRegion: null,
        receiverCountry: null,
        businessGeneratingTypeId: INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
        onetimeFee: null,
        recurringFee: null,
        commentRemarks: "",
        frequencyOfRecurringFee: null,
      });
      // if (!user?.roles.includes("Admin")) {
      //   getFirmSenderRegions(inquiryCreatingInfo.inquirySenderFirms[0].firmId);
      // }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inquiryCreatingInfo, countriesWithRegions]);

  const { showNotification } = useNotification();
  const handleClose = () => {
    toggleModal();
    // setBusinessGeneratingCheckbox({
    //   businessGeneratingTypeId: INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
    //   businessGeneratingTypeName: inquiryCreatingInfo?.inquiryBusinessGeneratingTypes.find(
    //     (x) =>
    //       x.businessGeneratingTypeId === INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
    //   )?.businessGeneratingTypeName,
    //   isCheck: true,
    // });
    setShowSpecializedSelect(0);
    setSubmitCount(0);
    setInitialValues({
      inquiryDate: null,
      inquirySenderFirm: user?.roles.includes("Admin") || inquiryCreatingInfo === null ? null : {
        value: inquiryCreatingInfo.inquirySenderFirms[0].firmId,
        label: inquiryCreatingInfo.inquirySenderFirms[0].firmName,
      },
      inquirySender: roleCheck || inquiryCreatingInfo === null ? null : {
        value: inquiryCreatingInfo.inquirySenders[0].inquirySenderId,
        label: inquiryCreatingInfo.inquirySenders[0].firstName + " " + inquiryCreatingInfo.inquirySenders[0].lastName
      },
      inquiryReceiverFirm: null,
      inquiryReceiver: null,
      subject: "",
      body: "",
      offeringType: null,
      mainService: null,
      status: inquiryCreatingInfo === null ? null : {
        value: INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING,
        label: inquiryCreatingInfo.inquiryStatusTypes.find(x => x.statusId === INQUIRY_CONSTANT.INQUIRY_STATUS_ID.PENDING)?.status
      },
      dealValue: null,
      closeDate: null,
      typeOfClient: inquiryCreatingInfo === null ? null : {
        value: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_ID.UNKNOWN,
        label: INQUIRY_CONSTANT.INQUIRY_TYPE_OF_CLIENT_NAME.UNKNOWN
      },
      requestedServices: null,
      senderRegion: null,
      senderCountry: null,
      receiverRegion: null,
      receiverCountry: null,
      businessGeneratingTypeId: INQUIRY_CONSTANT.BUSINESS_GENERATING_TYPE_ID.I_DONT_KNOW,
      onetimeFee: null,
      recurringFee: null,
      commentRemarks: "",
      frequencyOfRecurringFee: null,
    });

    formRef.current?.resetForm();
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const handleFeeInputChange = (
  //   e: React.ChangeEvent<HTMLInputElement>,
  //   setState: (value: any) => void,
  // ) => {
  //   let inputValue = e.target.value;
  //   inputValue = inputValue.replace(/[^0-9.]/g, "");
  //   setState(inputValue);
  // };

  const mappingInquiryReceiverFields = (e: any[]) => {
    const inquiryReceiverIds = e.map((item) => {
      const { value } = item;
      return value;
    });
    return inquiryReceiverIds;
  };

  // const checkIsDisabled = (values: any) => {
  //   return values.inquirySenderFirm?.value === values.inquiryReceiverFirm?.value;
  // }

  return (
    <AGModal
      toggleModal={handleClose}
      title="Add Inquiry"
      footer={
        <>
          <AGButton
            type="Primary"
            onClick={() => {
              setSubmitCount(submitCount + 1);
              formRef.current?.submitForm();
            }}
          >
            Save
          </AGButton>

          <AGButton
            type="Secondary"
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </AGButton>
        </>
      }
      visible={visible}
    >
      <CustomBackground>
        <FormContainer className="flex">
          <Formik
            innerRef={formRef}
            initialValues={initialValues}
            validationSchema={addInquirySchema}
            validateOnChange={submitCount > 0 ? true : false}
            validateOnBlur={submitCount > 0 ? true : false}
            onSubmit={(values) => {
              onPreCreateInquiry();
              var request = {
                inquiryDate: values.inquiryDate,
                inquirySenderFirmId: values.inquirySenderFirm?.value,
                inquirySenderId: values.inquirySender?.value,
                inquiryReceiverFirmId: values.inquiryReceiverFirm?.value,
                inquiryReceiverIds: mappingInquiryReceiverFields(values.inquiryReceiver),
                subject: values.subject ? values.subject.trim() : "",
                body: values.body ? values.body.trim() : "",
                offeringTypeId: values.offeringType?.value,
                mainServiceId: values.mainService?.value,
                statusId: values.status?.value,
                dealValue: values.dealValue,
                closeDate: values.closeDate,
                typeOfClientId: values.typeOfClient?.value,
                requestedServicesId: values.requestedServices?.value,
                senderRegionId: values.senderRegion?.value,
                senderCountryId: values.senderCountry?.value,
                receiverRegionId: values.receiverRegion?.value,
                receiverCountryId: values.receiverCountry?.value,
                businessGeneratingTypeId: values.businessGeneratingTypeId,
                onetimeFee: values.onetimeFee,
                recurringFee: values.recurringFee,
                commentRemarks: values.commentRemarks ? values.commentRemarks?.trim() : "",
                frequencyOfRecurringFeeId: values.frequencyOfRecurringFee?.value,
              };
              createInquiry(request);
            }}
          >
            {({ values, errors, setFieldValue, submitForm, validateForm, validateField, setValues }) => {
              return (
                <form
                  onSubmit={(e) => e.preventDefault()}
                  className="form"
                >
                  <div className="w-full">
                    <div className="flex">
                      <div className="label-title">Inquiry Date</div>
                      <span className="required">*</span>
                    </div>
                    <AddIconDatePicker>
                      <StyledDatePicker
                        dateFormat={"MM/dd/yyyy"}
                        isClearable
                        maxDate={new Date()}
                        onChange={(e: any) => {
                          setInquiryDate(e);
                          setFieldValue("inquiryDate", e);

                          if (moment(e || null).isAfter(values.closeDate)) {
                            setFieldValue("closeDate", null);
                          }
                        }}
                        selected={values.inquiryDate}
                        placeholderText="mm/dd/yyyy"
                        onKeyDown={handleNumericDateInput}
                      />
                    </AddIconDatePicker>
                  </div>
                  {errors.inquiryDate && <div className="error">This field is required.</div>}
                  <div className="mb-[1rem] mt-[1rem]">
                    <div className="flex">
                      <div className="label-title">Inquiry Sender Organization</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      placeholder="Select organization"
                      value={values.inquirySenderFirm}
                      onChange={(e: any) => {
                        if (e !== null) {
                          getSendersByFirmId(e.value);
                        }
                        setFieldValue("inquirySender", null);
                        setFieldValue("inquirySenderFirm", e);
                        setInquirySenders([]);
                      }}
                      isDisabled={!user?.roles.includes("Admin")}
                      isClearable
                      options={inquiryCreatingInfo?.inquirySenderFirms
                        ?.map((e) => {
                          return {
                            value: e.firmId,
                            label: e.firmName,
                            isDisabled: e.firmId === values.inquiryReceiverFirm?.value,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                    />
                    {errors.inquirySenderFirm && (
                      <div className="error">This field is required.</div>
                    )}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Inquiry Sender</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      placeholder="Select inquiry sender"
                      value={values.inquirySender}
                      isClearable
                      isDisabled={!roleCheck}
                      onChange={(e: any) => {
                        setFieldValue("inquirySender", e);
                      }}
                      options={inquirySenders
                        ?.map((e) => {
                          return {
                            value: e.individualId,
                            label: e.firstName + " " + e.lastName,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                    />
                    {errors.inquirySender && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Inquiry Receiver Organization</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      placeholder="Select organization"
                      value={values.inquiryReceiverFirm}
                      onChange={(e: any) => {
                        setShowSpecializedSelect(0);
                        setInquiryReceivers([]);

                        if (e !== null) {
                          getReceiversByFirmId(e.value);
                        }
                        setValues((prev : any)=> ({
                          ...prev,
                          inquiryReceiverFirm: e,
                          inquiryReceiver: null,
                          offeringType: null,
                          mainService: null,
                        }));
                      }}
                      isClearable
                      options={inquiryCreatingInfo?.inquiryReceiverFirms
                        ?.map((e) => {
                          return {
                            value: e.firmId,
                            label: e.firmName,
                            isDisabled: e.firmId === values.inquirySenderFirm?.value,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                    />
                    {errors.inquiryReceiverFirm && (
                      <div className="error">This field is required.</div>
                    )}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Inquiry Receiver</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      isMulti
                      placeholder="Select inquiry receiver"
                      value={values.inquiryReceiver}
                      onChange={(e: any) => {
                        setFieldValue("inquiryReceiver", e);
                      }}
                      options={inquiryReceivers
                        ?.map((e) => {
                          return {
                            value: e.individualId,
                            label: e.firstName + " " + e.lastName,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                    />
                    {errors.inquiryReceiver && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Sender Country</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      placeholder={"Select country"}
                      isClearable
                      value={values.senderCountry}
                      options={countriesWithRegions
                        .map((e) => {
                          return {
                            value: e.countryId,
                            label: e.countryName,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                      onChange={(e: any) => {
                        const region = countriesWithRegions.find(x => x.countryId === e?.value);
                        setValues((prev: any) => ({
                          ...prev,
                          senderCountry: e,
                          senderRegion: e
                            ? { value: region?.regionId, label: region?.regionName }
                            : null,
                        }));
                      }}
                    />
                    {errors.senderCountry && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Sender Region</div>
                      {/* <span className="required">*</span> */}
                    </div>
                    <AGSelect
                      placeholder={""}
                      isDisabled
                      value={values.senderRegion}
                      components={{DropdownIndicator: null}}
                    />
                    {/* {errors.senderRegion && <div className="error">This field is required.</div>} */}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Receiver Country</div>
                      <span className="required">*</span>
                    </div>
                    <AGSelect
                      placeholder={"Select receiver country"}
                      isClearable
                      value={values.receiverCountry}
                      options={countriesWithRegions
                        .map((e) => {
                          return {
                            value: e.countryId,
                            label: e.countryName,
                          };
                        })
                        .sort((a, b) => compare(a, b, "label"))}
                      onChange={(e: any) => {
                        const region = countriesWithRegions.find(x => x.countryId === e?.value);
                        setValues((prev: any) => ({
                          ...prev,
                          receiverCountry: e,
                          receiverRegion: e
                            ? { value: region?.regionId, label: region?.regionName }
                            : null,
                        }));
                      }}
                    />
                    {errors.receiverCountry && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Receiver Region</div>
                      {/* <span className="required">*</span> */}
                    </div>
                    <AGSelect
                      placeholder={""}
                      isDisabled
                      value={values.receiverRegion}
                      components={{DropdownIndicator: null}}
                    />
                    {/* {errors.receiverRegion && <div className="error">This field is required.</div>} */}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Subject</div>
                      <span className="required">*</span>
                    </div>
                    <AGInput
                      onChange={(e) => {
                        setFieldValue("subject", e.target.value);
                      }}
                      className="w-full"
                    />
                    {errors.subject && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Message</div>
                      <span className="required">*</span>
                    </div>
                    <AGTextarea
                      onChange={(e) => {
                        setFieldValue("body", e.target.value);
                      }}
                      style={{
                        width: "100%",
                        height: "250px",
                        resize: "none",
                      }}
                    />
                    {errors.body && <div className="error">This field is required.</div>}
                  </div>
                  <div className="mb-[1rem]">
                    <div className="label-title">Offering Type</div>
                    <div className=""></div>
                    <AGSelect
                      isClearable
                      placeholder="Select offering type"
                      onChange={(e: any) => {
                        setFieldValue("mainService", null);
                        setFieldValue("offeringType", e);
                        setFieldValue("onetimeFee", null);
                        setFieldValue("recurringFee", null);
                        setFieldValue("frequencyOfRecurringFee", null);

                        if (e !== null) {
                          setShowSpecializedSelect(e.value);
                          if (e.value === OFFERING_TYPE.SECONDMENT){
                            setIsSecondmentSelected(true);
                          }else{
                            setIsSecondmentSelected(false);
                          }
                        } else {
                          setIsSecondmentSelected(false);
                          setShowSpecializedSelect(0);
                        }
                      }}
                      options={inquiryCreatingInfo?.inquiryOfferingTypes
                        .filter(x =>
                          isAdmin
                            ? true
                            : x.offeringTypeId !== OFFERING_TYPE.SECONDMENT
                        )
                        ?.map(e => ({
                          value: e.offeringTypeId,
                          label: e.offeringTypeName
                        }))}
                      value={values.offeringType}
                    />
                  </div>

                  {showSpecializedSelect === 1 ? (
                    <div className="mb-[1rem]">
                      <div className="flex">
                        <div className="label-title">Specialized Service</div>
                        <span className="required">*</span>
                      </div>
                      <AGSelect
                        isClearable
                        value={values.mainService}
                        placeholder="Select service"
                        onChange={(e: any) => {
                          setFieldValue("mainService", e);
                        }}
                        options={
                          (() => {
                            const options = (mainServices?.map((e) => ({
                              value: e.mainServiceId,
                              label: e.mainServiceName,
                            })) || []).sort((a, b) => a.label.localeCompare(b.label));

                            options.push({ value: -1, label: INQUIRY_MORE_OPTION.OTHER });

                            return options;
                          })()
                        }
                      />
                      {errors.mainService && <div className="error">This field is required.</div>}
                    </div>
                  ) : (
                    <></>
                  )}

                  {showSpecializedSelect === 2 ? (
                    <div className="mb-[1rem]">
                      <div className="flex">
                        <div className="label-title">Specialized Product</div>
                        <span className="required">*</span>
                      </div>
                      <AGSelect
                        isClearable
                        value={values.mainService}
                        placeholder="Select product"
                        onChange={(e: any) => {
                          setFieldValue("mainService", e);
                        }}
                        options={
                          (() => {
                            const options = (mainProducts?.map((e) => ({
                              value: e.mainServiceId,
                              label: e.mainServiceName,
                            })) || []).sort((a, b) => a.label.localeCompare(b.label));

                            options.push({ value: -1, label: INQUIRY_MORE_OPTION.OTHER });

                            return options;
                          })()
                        }
                      />
                      {errors.mainService && <div className="error">This field is required.</div>}
                    </div>
                  ) : (
                    <></>
                  )}

                  {showSpecializedSelect === 3 ? (
                    <div className="mb-[1rem]">
                      <div className="flex">
                        <div className="label-title">Specialized Service</div>
                        <span className="required">*</span>
                      </div>
                      <AGSelect
                        isClearable
                        value={values.mainService}
                        placeholder="Select service"
                        onChange={(e: any) => {
                          setFieldValue("mainService", e);
                        }}
                        options={
                          (() => {
                            const options = (mainSecondments?.map((e) => ({
                              value: e.mainServiceId,
                              label: e.mainServiceName,
                            })) || []).sort((a, b) => a.label.localeCompare(b.label));

                            options.push({ value: -1, label: INQUIRY_MORE_OPTION.OTHER });

                            return options;
                          })()
                        }
                      />
                      {errors.mainService && <div className="error">This field is required.</div>}
                    </div>
                  ) : (
                    <></>
                  )}
                  {
                    isAdmin && <div className="mb-[1rem]">
                      <div className="label-title">Requested Services</div>
                      <AGSelect
                        isClearable
                        value={values.requestedServices}
                        placeholder="Select requested service"
                        onChange={(e: any) => {
                          setFieldValue("requestedServices", e);
                        }}
                        options={inquiryCreatingInfo?.inquiryRequestedServiceTypes?.map((e) => {
                          return {
                            value: e.requestedServicesTypeId,
                            label: e.requestedServicesTypeName,
                          };
                        })}
                      />
                    </div>
                  }
                  <div className="mb-[1rem]">
                    <div className="label-title">Type of Client</div>
                    <AGSelect
                      value={values.typeOfClient}
                      placeholder="Select type of client"
                      onChange={(e: any) => {
                        setFieldValue("typeOfClient", e);
                      }}
                      options={
                        (() => {
                          const specialLabels = ["Unknown", "Other"];

                          const options = inquiryCreatingInfo?.inquiryTypeOfClients?.map((e) => ({
                            value: e.typeOfClientId,
                            label: e.typeOfClientName,
                          })) || [];

                          const sorted = options.sort((a, b) => a.label.localeCompare(b.label));

                          const normal = sorted.filter(opt => !specialLabels.includes(opt.label));
                          const special = sorted.filter(opt => specialLabels.includes(opt.label));

                          return [...normal, ...special.sort((a,b) => b.label.localeCompare(a.label))];
                        })()
                      }
                    />
                  </div>
                  <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Status</div>
                    </div>
                    <AGSelect
                      placeholder="Select status"
                      value={values.status}
                      onChange={(e: any) => {
                        setFieldValue("status", e);
                      }}
                      options={inquiryCreatingInfo?.inquiryStatusTypes?.slice()
                        .sort((a, b) => a.statusId - b.statusId).map((e) => {
                          return {
                            value: e.statusId,
                            label: e.status,
                          };
                        })}
                    />
                  </div>
                  {/* <div className="mb-[1rem]">
                    <div className="label-title">Deal Value (USD)</div>
                    <AddIconCurrencyInput>
                      <AGCurrencyInput
                        onChange={(e: any) => {
                          let value = e.target.value;

                          if (value !== null && value !== "") {
                            setFieldValue("dealValue", Math.trunc(Number(value) * 100) / 100);
                          } else {
                            setFieldValue("dealValue", null);
                          }

                          setTimeout(() => {
                            validateField("dealValue");
                          }, 0);
                        }}
                        placeholder="Enter non-zero deal value (e.g., $10.00)"
                      />
                    </AddIconCurrencyInput>
                    {errors.dealValue && <div className="error">{String(errors.dealValue)}</div>}
                  </div> */}
                  {/* <div className="mb-[1rem]">
                    <div className="flex">
                      <div className="label-title">Business Generating?</div>
                    </div>
                    <div className="flex items-center mt-[0.5rem]">
                      {inquiryCreatingInfo?.inquiryBusinessGeneratingTypes.map((x) => (
                        <div
                          className={`flex items-center ${!isMobileScreen ? "w-1/5" : "w-1/3"} `}
                        >
                          <AGRadioButtonV2
                            checked={
                              businessGeneratingCheckBox?.businessGeneratingTypeId ===
                              x.businessGeneratingTypeId
                                ? businessGeneratingCheckBox!.isCheck
                                : false
                            }
                            onChange={(e) => {
                              setBusinessGeneratingCheckbox({
                                businessGeneratingTypeId: x.businessGeneratingTypeId,
                                businessGeneratingTypeName: x.businessGeneratingTypeName,
                                isCheck: true,
                              });
                              setFieldValue("businessGeneratingTypeId", x.businessGeneratingTypeId);
                            }}
                          />
                          <div className="mt-[3px] ml-[5px]">
                            <span>{x.businessGeneratingTypeName}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {errors.businessGeneratingTypeId && (
                      <div className="error">This field is required.</div>
                    )}
                  </div> */}
                  {!isSecondmentSelected && (
                    <div className="mb-[1rem]">
                      <div className="label-title">One Time Fee (USD)</div>
                      <AddIconCurrencyInput>
                        <AGCurrencyInput
                          value={values?.onetimeFee}
                          onChange={(e: any) => {
                            let value = e.target.value;

                            let fee = value === "" ? null : Number(value);
                            if (fee !== null) {
                              setFieldValue("onetimeFee", Math.trunc(fee * 100) / 100);
                            } else {
                              setFieldValue("onetimeFee", null);
                            }

                            setTimeout(() => {
                              validateField("onetimeFee");
                            }, 0);
                          }}
                          placeholder="Enter non-zero one time fee (e.g., $10.00)"
                        />
                      </AddIconCurrencyInput>
                      {errors.onetimeFee && <div className="error">{String(errors.onetimeFee)}</div>}
                    </div>
                  )}

                  {!isSecondmentSelected && (
                    <div className="mb-[1rem]">
                      <div className="label-title">Recurring Fee (USD)</div>
                      <AddIconCurrencyInput>
                        <AGCurrencyInput
                          placeholder="Enter non-zero recurring fee (e.g., $10.00)"
                          onChange={(e: any) => {
                            let fee = e.target.value === "" ? null : Number(e.target.value);
                            if (fee !== null) {
                              setFieldValue("recurringFee", Math.trunc(fee * 100) / 100);
                            } else {
                              setFieldValue("recurringFee", null);
                            }

                            setTimeout(() => {
                              validateField("recurringFee");
                            }, 0);
                          }}
                          defaultValue={"0"}
                        />
                      </AddIconCurrencyInput>
                      {errors.recurringFee && (
                        <div className="error">{String(errors.recurringFee)}</div>
                      )}
                    </div>)}

                  {!isSecondmentSelected && (
                    <div className="mb-[1rem]">
                      <div className="flex">
                        <div className="label-title">Frequency of Recurring Fee</div>
                      </div>
                      <AGSelect
                        isClearable
                        placeholder="Select frequency of recurring fee"
                        value={values.frequencyOfRecurringFee}
                        onChange={(e: any) => {
                          setFieldValue("frequencyOfRecurringFee", e);
                        }}
                        options={inquiryCreatingInfo?.inquiryFrequencyOfRecurringFeeTypes?.map(
                          (e) => {
                            return {
                              value: e.frequencyId,
                              label: e.frequencyTypeName,
                            };
                          },
                        )}
                      />
                    </div>)}

                  <div className="mb-[1rem]">
                    <div className="label-title">Close Date</div>
                    <AddIconDatePicker>
                      <StyledDatePicker
                        isClearable
                        minDate={inquiryDate ? moment(inquiryDate).toDate() : undefined}
                        onChange={(e) => {
                          setFieldValue("closeDate", e ?? null);
                        }}
                        onClickOutside={() => {
                          if (isMobileScreen) {
                            setTimeout(() => {
                              if (document.activeElement instanceof HTMLElement) {
                                document.activeElement.blur();
                              }
                            }, 200)
                          }
                        }}
                        popperPlacement={`top-start`}
                        dateFormat={"MM/dd/yyyy"}
                        selected={values.closeDate}
                        placeholderText="mm/dd/yyyy"
                        onKeyDown={handleNumericDateInput}
                      />
                    </AddIconDatePicker>
                  </div>
                  <div className="mb-[1rem]">
                    <div className="label-title touch-none">Comments/Remarks (including Estimated Fees, if known)</div>
                    <AGInput
                      onChange={(e: any) => {
                        setFieldValue("commentRemarks", e.target.value);
                      }}
                      placeholder="Enter comments/remarks"
                      className="w-full touch-none"
                    />
                  </div>
                </form>
              );
            }}
          </Formik>
        </FormContainer>
      </CustomBackground>
    </AGModal >
  );
};
export default AddInquiryModal;
